import Features from "../uidispatcherapi/Features";
import { FeatureSessionStore } from "../uidispatcherapi/FeatureSessionStore";

export default {
    isActiveNewStoreListOverviewPage() {
        return FeatureSessionStore.getMembershipFor(Features.CI_NEW_STORELIST_PAGE) === "B";
    },

    isArticleSourcesFacetActive() {
        return FeatureSessionStore.getMembershipFor(Features.ARTICLE_SOURCES_FACET) === "B";
    },

    isNewFooterActive() {
        return FeatureSessionStore.getMembershipFor(Features.CI_NEW_FOOTER) === "B";
    },

    shouldShowMerchantOfferPage() {
        return FeatureSessionStore.getMembershipFor(Features.SHOW_MERCHANT_OFFER_PAGE) === "B";
    },

    isSLCashAndCarryVisible() {
        return FeatureSessionStore.getMembershipFor(Features.CI_SL_CASH_AND_CARRY_VISIBLE) === "B";
    },

    isSideCaddyEnabled() {
        return FeatureSessionStore.getMembershipFor(Features.ENABLE_SIDE_CADDY) === "B";
    },

    shouldUseBlockGifs() {
        return FeatureSessionStore.getMembershipFor(Features.CI_ENABLE_BANNER_GIFS) === "A";
    },

    isCCGPlacementActive() {
        return FeatureSessionStore.getMembershipFor(Features.CUSTOMER_CATEGORY_GROUP_BANNER_PLACEMENT) === "B";
    },

    areMultipleCreativesEnabled() {
        return FeatureSessionStore.getMembershipFor(Features.CI_MULTIPLE_CREATIVES) === "B";
    },

    isOrderHabitsFeatureEnabled() {
        return FeatureSessionStore.getMembershipFor(Features.ENABLE_ORDER_HABITS) === "B";
    },

    isSearchDebugEnabled() {
        return FeatureSessionStore.getMembershipFor(Features.SEARCH_DEBUG) === "B";
    }
};
